function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UnstyledInput } from "../../unstyled/input/UnstyledInput";

/*
    Returns a basic uncontrolled text input

    props
        (string)  classPrepend  The base name of all classes, to make styling specific to an implementation
        (string)  label         Input label text shown to the user
        (string)  name          Unique name to differentiate the field from other ones in the same form
        (string)  type          Optional. HTML input type ("text", "email", "password", etc)
        (boolean) disabled      Optional. When true, prevents user from changing or selecting the input
        (boolean) error         Optional. When true, allows styling to show there is an issue with the input value
        (string)  helperText    Optional. Display text below the input
        (props)   rest          other props to apply to the MUI Input
*/

const UncontrolledInput = ({
  classPrepend = "styled",
  label = "",
  name = "",
  type = "text",
  disabled = false,
  error = false,
  helperText = "",
  placeholder = "",
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(UnstyledInput, _extends({
    classPrepend: classPrepend,
    label: label,
    name: name,
    type: type,
    disabled: disabled,
    error: error,
    helperText: helperText,
    placeholder: placeholder
  }, rest));
};
export { UncontrolledInput };